import { useMemo } from "react";
import { useLocation } from "react-router-dom";

/**
 * Get the url search params and return an object with its values
 * @example const { user } = useUrlSearchParams<{ user?: string }>();
 */
const useUrlSearchParams = <
  Params extends { [K in keyof Params]?: string } = NonNullable<unknown>,
>(): Params => {
  const { search } = useLocation();

  const params = useMemo(() => {
    const urlSearchParams = new URLSearchParams(search);
    const paramsObject = {};
    for (const [key, value] of urlSearchParams) {
      paramsObject[key] = value;
    }
    return paramsObject as Params;
  }, [search]);

  return params;
};

export default useUrlSearchParams;
